import React from 'react';
import PropTypes from 'prop-types';

import StyledComponent from '~/components/Styled/Styled';
import css from '~/components/ExtraInfoCard/ExtraInfoCard.scss';

class ExtraInfoCard extends React.PureComponent {
  render() {
    return (
      <div className={`${this.props.showBackground ? css.background : null} ${css.container}`}>
        {this.props.title && <div className={css.title}>{this.props.title}</div>}
        {this.props.extraInfo.map(info => (
          <div key={info.label} className={css.info}>
            <div className={css.label}>{info.label}</div>
            <div className={css.value}>{info.value}</div>
          </div>
        ))}
      </div>
    );
  }
}

ExtraInfoCard.propTypes = {
  title: PropTypes.string,
  extraInfo: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
  showBackground: PropTypes.bool,
};

ExtraInfoCard.defaultProps = {
  title: null,
  showBackground: false,
};

ExtraInfoCard.displayName = 'ExtraInfoCard';

export default StyledComponent(ExtraInfoCard, [css]);
